<template>
    <b-container :style="container_style" fluid id="container">
        <transition enter-active-class="animated fadeIn" name="router-anim">
            <router-view :key="$route.path"></router-view>
        </transition>

        <slot></slot>
    </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        noNavBar: { type: Boolean, default: false },
        marginTop: { type: String, default: "60px" },
    },
    computed: {
        ...mapGetters(["messages"]),
        container_style() {
            if (this.noNavBar) {
                return {};
            } else {
                return { "margin-top": this.marginTop || "60px" };
            }
        },
    },
    watch: {
        messages() {
            var title = {
                primary: "Message",
                secondary: "Message",
                danger: "Error",
                warning: "Warning",
                success: "Success",
                info: "Info",
            }[this.messages.type];

            this.$bvToast.toast(this.messages.message, {
                title: title,
                variant: this.messages.type,
                autoHideDelay: 5000,
                solid: true,
                append: true,
            });
        },
    },
};
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css";
</style>
